<template>
     <div class="kp-no-page">
      <div class="container no-padding">
        <div class="no-page-content">
          <div class="empty_state_logo">
            <svg class="empty_state_svg" width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M29 0H3C1.3125 0 0 1.375 0 3V21C0 22.6875 1.3125 24 3 24H29C30.625 24 32 22.6875 32 21V3C32 1.375 30.625 0 29 0ZM3 2H29C29.5 2 30 2.5 30 3V5.625C28.625 6.75 26.625 8.375 20.5625 13.1875C19.5 14.0625 17.4375 16.0625 16 16C14.5 16.0625 12.4375 14.0625 11.375 13.1875C5.3125 8.375 3.3125 6.75 2 5.625V3C2 2.5 2.4375 2 3 2ZM29 22H3C2.4375 22 2 21.5625 2 21V8.1875C3.375 9.375 5.625 11.1875 10.125 14.75C11.4375 15.8125 13.6875 18.0625 16 18C18.25 18.0625 20.5 15.8125 21.8125 14.75C26.3125 11.1875 28.5625 9.375 30 8.1875V21C30 21.5625 29.5 22 29 22Z" fill="#464B52"/>
            </svg>
          </div>
          <div class="empty_state_text-content">
            <div class="empty_state_title">
              <span>{{ $t('account.empty.title') }}</span>
            </div>
            <div class="empty_state_subtitle">
              <span v-html="$t('account.empty.subtitle')"></span>
            </div>
          </div>
          <!-- <a :href="$t('account.empty.urlExtensions')" class="empty_state_link">{{ $t('account.empty.link') }}<span class="icon-kp-external"></span></a> -->
          <a class="btn empty_state_button--primary" :href="knowSendLink" target="_blank">
            {{ $t('account.empty.klicksend') }}
          </a>
          <a class="btn empty_state_button" @click="modalOpen('edit-account'); resetActiveAccount();">
            {{ $t('account.empty.button') }}
          </a>
        </div>
      </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  methods: mapActions({
    modalOpen: 'modal/open',
    resetActiveAccount: 'account/resetActive',
  }),
  computed: {
    knowSendLink() {
      return 'https://extensoes.hotmart.com/precos-externa-2#ls-hsHq1EYj7FfRqcYmVnS2vy';
    },
  },
};
</script>



// WEBPACK FOOTER //
// EmptyBoard.vue?7c43a800